import React from 'react';
import { MessageCircle } from 'lucide-react';

const WHATSAPP_MSG = 'Hola DOMINICAN SHIPPING! Quiero informacion sobre envios a Republica Dominicana';

const WhatsAppFloat = ({ whatsappNumber }) => (
  <a href={`https://wa.me/${whatsappNumber}?text=${encodeURIComponent(WHATSAPP_MSG)}`} target="_blank" rel="noreferrer"
    className="fixed bottom-6 right-6 z-50 bg-green-500 hover:bg-green-600 text-white p-4 rounded-full shadow-2xl shadow-green-500/40 transition-all hover:scale-110"
    style={{ animation: 'bounce 2s infinite' }} data-testid="whatsapp-float-btn">
    <MessageCircle className="h-7 w-7" />
  </a>
);

export default WhatsAppFloat;
